import style from './crypto-arrow.module.scss'
import Image from "next/dist/client/image";
import { InView } from 'react-intersection-observer';
import animations from '@styles/animations.module.scss'

const CryptoArrow = (props: any) => {
    let { state } = props;
    return (
        <InView triggerOnce={true}>
            {({ inView, ref, entry }) => {
                if (inView) {
                    entry?.target.classList.add(animations.active);
                }
                return (
        <>
            <div ref={ref} className={`${style.crypto} ${animations.scroll__animation}`}>
                <div className={style.crypto__block}>
                    <Image alt="arrow" width="40px" height="40px" src={state.img} />
                </div>
                <div className={style.crypto__arrow}>
                    <div className={style.crypto__arrow_top}>
                        
                    </div>
                    <svg className={style.crypto__arrow_center} width="100" height="100">
                        <line className={style.crypto__dotted__line} x1="0" y1="50" x2="100" y2="50" />
                    </svg>
                    <div className={style.crypto__arrow_bottom}>
                        
                    </div>
                </div>
            </div>

        </>
        )
    }}
</InView>
    )
}

export default CryptoArrow;
